<template>
    <div
        class="menu-container pa-2"
        :style="{left: `${horizontal}px`, top: `${vertical}px`, backgroundColor: 'white'}"
    >
        <div
            class="d-flex align-center pa-2 drawer-menu-item"
            v-if="isEmptyPosition"
            @click.stop="handleClick('create')"
        >
            <v-icon class="drawer-menu-icon">add</v-icon>
            <p class="drawer-menu-option">Add drawer</p>
        </div>
        <div
            class="d-flex align-center pa-2 drawer-menu-item"
            v-if="!isEmptyPosition"
            @click.stop="handleClick('edit')"
        >
            <v-icon class="drawer-menu-icon">create</v-icon>
            <p class="drawer-menu-option">Edit drawer</p>
        </div>
        <div
            class="d-flex align-center pa-2 drawer-menu-item"
            v-if="!isEmptyPosition"
            @click.stop="handleClick('delete')"
        >
            <v-icon class="drawer-menu-icon">delete</v-icon>
            <p class="drawer-menu-option">Delete drawer</p>
        </div>
    </div>
</template>

<script>
export default {
    name: "DrawerOptionsMenu",
    components: {

    },
    props: {
        horizontal: {
            type: Number,
        },
        vertical: {
            type: Number,
        },
        isEmptyPosition: {
            type: Boolean
        }
    },
    data() {
        return {
            active: false,
        };
    },
    computed: {

    },
    methods: {
        handleClick(action) {
            switch (action) {
                case "create":
                    this.$emit('open-form', "drawer", "add");
                    break;
                case "edit":
                    this.$emit('open-form', "drawer", "edit");
                    break;
                case "delete":
                    this.$emit('delete-drawer');
                    break;
                default:
                    break;
            }
            this.active = !this.active;
        },
    }
}
</script>

<style scoped>
.menu-container{
    position: absolute;
    box-shadow: 1px 1px 5px rgb(88, 88, 88);
    display: flex;
    flex-direction: column;
    border-radius: 5px;
}
.drawer-menu-option{
    margin-bottom: 0px;
    margin-left: 5px;
}
.drawer-menu-icon{
  font-size: 15px !important;
  transition: none !important;
}
.drawer-menu-item{
    cursor: pointer;
    border-radius: 5px;
}
.drawer-menu-item:active {
    background-color: #42A1B6;
}

.drawer-menu-item:hover {
  color: white;
  background-color: #42A1B6;
}
.drawer-menu-item:hover .drawer-menu-icon {
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/Home/Content/Tabs/InsidePlan/menus/DrawerOptionsMenu.vue